webpackJsonp([1],{

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  "data-v-cd376aa4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSingerList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSingerDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(51);




function getSingerList() {
  var url = 'https://c.y.qq.com/v8/fcg-bin/v8.fcg';

  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__config__["b" /* commonParams */], {
    channel: 'singer',
    page: 'list',
    key: 'all_all_all',
    pagesize: 100,
    pagenum: 1,
    hostUin: 0,
    needNewCode: 0,
    platform: 'yqq'
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__config__["c" /* options */]);
}

function getSingerDetail(singerId) {
  var url = 'https://c.y.qq.com/v8/fcg-bin/fcg_v8_singer_track_cp.fcg';

  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__config__["b" /* commonParams */], {
    hostUin: 0,
    needNewCode: 0,
    platform: 'yqq',
    order: 'listen',
    begin: 0,
    num: 80,
    songstatus: 1,
    singermid: singerId
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_jsonp__["a" /* default */])(url, data, __WEBPACK_IMPORTED_MODULE_2__config__["c" /* options */]);
}

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export saveSearch */
/* unused harmony export deleteSearch */
/* unused harmony export clearSearch */
/* unused harmony export loadSearch */
/* unused harmony export savePlay */
/* unused harmony export loadPlay */
/* harmony export (immutable) */ __webpack_exports__["b"] = saveFavorite;
/* harmony export (immutable) */ __webpack_exports__["c"] = deleteFavorite;
/* harmony export (immutable) */ __webpack_exports__["a"] = loadFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_good_storage__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_good_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_good_storage__);


var SEARCH_KEY = '__search__';
var SEARCH_MAX_LEN = 15;

var PLAY_KEY = '__play__';
var PLAY_MAX_LEN = 200;

var FAVORITE_KEY = '__favorite__';
var FAVORITE_MAX_LEN = 200;

function insertArray(arr, val, compare, maxLen) {
  var index = arr.findIndex(compare);
  if (index === 0) {
    return;
  }
  if (index > 0) {
    arr.splice(index, 1);
  }
  arr.unshift(val);
  if (maxLen && arr.length > maxLen) {
    arr.pop();
  }
}

function deleteFromArray(arr, compare) {
  var index = arr.findIndex(compare);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

function saveSearch(query) {
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);
  insertArray(searches, query, function (item) {
    return item === query;
  }, SEARCH_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(SEARCH_KEY, searches);
  return searches;
}

function deleteSearch(query) {
  var searches = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);
  deleteFromArray(searches, function (item) {
    return item === query;
  });
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(SEARCH_KEY, searches);
  return searches;
}

function clearSearch() {
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.remove(SEARCH_KEY);
  return [];
}

function loadSearch() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(SEARCH_KEY, []);
}

function savePlay(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(PLAY_KEY, []);
  insertArray(songs, song, function (item) {
    return song.id === item.id;
  }, PLAY_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(PLAY_KEY, songs);
  return songs;
}

function loadPlay() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(PLAY_KEY, []);
}

function saveFavorite(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);
  insertArray(songs, song, function (item) {
    return song.id === item.id;
  }, FAVORITE_MAX_LEN);
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(FAVORITE_KEY, songs);
  return songs;
}

function deleteFavorite(song) {
  var songs = __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);
  deleteFromArray(songs, function (item) {
    return item.id === song.id;
  });
  __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.set(FAVORITE_KEY, songs);
  return songs;
}

function loadFavorite() {
  return __WEBPACK_IMPORTED_MODULE_0_good_storage___default.a.get(FAVORITE_KEY, []);
}

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function shuffle(arr) {
  var _arr = arr.slice();
  for (var i = 0; i < _arr.length; i++) {
    var j = getRandomInt(0, i);
    var t = _arr[i];
    _arr[i] = _arr[j];
    _arr[j] = t;
  }
  return _arr;
}

/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SINGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_PLAYING_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_FULL_SCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PLAYLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_SEQUENCE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_PLAY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CURRENT_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DISC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_FAVORITE_LIST; });
var SET_SINGER = 'SET_SINGER';
var SET_PLAYING_STATE = 'SET_PLAYING_STATE';
var SET_FULL_SCREEN = 'SET_FULL_SCREEN';
var SET_PLAYLIST = 'SET_PLAYLIST';
var SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST';
var SET_PLAY_MODE = 'SET_PLAY_MODE';
var SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
var SET_DISC = 'SET_DISC';
var SET_FAVORITE_LIST = 'SET_FAVORITE_LIST';

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  "data-v-27e21343",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(568),
  /* scopeId */
  "data-v-31e3dab7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  "data-v-078e028e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(570),
  /* scopeId */
  "data-v-42014d0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports) {



function noop() {}

window.MessageChannel = noop;
window.setImmediate = noop;

/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ga__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_singer_singer__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_singer_singer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_singer_singer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_rank_rank__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_rank_rank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_rank_rank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_search_search__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_search_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_search_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_singer_detail_singer_detail__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_singer_detail_singer_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_singer_detail_singer_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_user_center_user_center__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_user_center_user_center___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_user_center_user_center__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_audiobook_audiobook__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_audiobook_audiobook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_audiobook_audiobook__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/audioBook'
  }, {
    path: '/audiobook/resource/:id',
    component: __WEBPACK_IMPORTED_MODULE_8_components_audiobook_audiobook___default.a
  }, {
    path: '/kindergartener/resource/:id',
    component: __WEBPACK_IMPORTED_MODULE_8_components_audiobook_audiobook___default.a
  }, {
    path: '/singer',
    name: 'Singer',
    component: __WEBPACK_IMPORTED_MODULE_3_components_singer_singer___default.a,
    children: [{
      path: ':id',
      component: __WEBPACK_IMPORTED_MODULE_6_components_singer_detail_singer_detail___default.a
    }]
  }, {
    path: '/rank',
    name: 'Rank',
    component: __WEBPACK_IMPORTED_MODULE_4_components_rank_rank___default.a
  }, {
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_5_components_search_search___default.a
  }, {
    path: '/user',
    name: 'UserCenter',
    component: __WEBPACK_IMPORTED_MODULE_7_components_user_center_user_center___default.a
  }]
});

__WEBPACK_IMPORTED_MODULE_2_vue_ga___default()(router, 'UA-105074-24');
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-9073bbce",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRecommend */
/* unused harmony export getDiscList */
/* unused harmony export getSongList */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAudioBook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




function getRecommend() {
  var url = 'https://apiservices.kimy.com.tw/mag/api/getSliders';
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function getDiscList() {
  var url = 'https://apiservices.kimy.com.tw/mag/api/getMaglist';
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
    console.log('getDiscList=>', res.data);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function getSongList(disstid) {
  var url = 'https://apiservices.kimy.com.tw/mag/api/getCdList/' + disstid;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

function getAudioBook(bookid) {
  var url = 'https://api.hsin-yi.org.tw/audiobook/' + bookid;
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (res) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLyric;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





function getLyric(mid) {
  var url = '/api/lyric';

  var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_2__config__["b" /* commonParams */], {
    songmid: mid,
    platform: 'yqq',
    hostUin: 0,
    needNewCode: 0,
    categoryId: 10000000,
    pcachetime: +new Date(),
    format: 'json'
  });

  return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, {
    params: data
  }).then(function (res) {
    console.log('getLyricAPI', res.data);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(res.data);
  });
}

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonp;
/* unused harmony export param */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jsonp__);



function jsonp(url, data, option) {
  url += (url.indexOf('?') < 0 ? '?' : '&') + param(data);
  console.log('url', url);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_jsonp___default()(url, option, function (err, data) {
      if (!err) {
        resolve(data);
      } else {
        reject(err);
      }
    });
  });
}

function param(data) {
  var url = '';
  for (var k in data) {
    var value = data[k] !== undefined ? data[k] : '';
    url += '&' + k + '=' + encodeURIComponent(value);
  }

  return url ? url.substring(1) : '';
}

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Singer = function Singer(_ref) {
  var id = _ref.id,
      name = _ref.name;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Singer);

  this.id = id;
  this.name = name;
  this.avatar = "https://y.gtimg.cn/music/photo_new/T001R300x300M000" + id + ".jpg?max_age=2592000";
};

/* harmony default export */ __webpack_exports__["a"] = (Singer);

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_hack__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_hack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_common_js_hack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_stylus_index_styl__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_stylus_index_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_common_stylus_index_styl__);












__WEBPACK_IMPORTED_MODULE_6_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_lazyload___default.a, {
  loading: __webpack_require__(208)
});

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App___default.a);
  }
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectPlay", function() { return selectPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insertSong", function() { return insertSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSong", function() { return deleteSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSongList", function() { return deleteSongList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveFavoriteList", function() { return saveFavoriteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFavoriteList", function() { return deleteFavoriteList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_cache__ = __webpack_require__(141);



function findIndex(list, song) {
  return list.findIndex(function (item) {
    return item.id === song.id;
  });
}
var selectPlay = function selectPlay(_ref, _ref2) {
  var commit = _ref.commit,
      state = _ref.state;
  var list = _ref2.list,
      index = _ref2.index;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], list);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], list);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], index);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
};

var insertSong = function insertSong(_ref3, song) {
  var commit = _ref3.commit,
      state = _ref3.state;

  var playlist = state.playlist.slice();
  var sequenceList = state.sequenceList.slice();
  var currentIndex = state.currentIndex;

  var currentSong = playlist[currentIndex];

  var fpIndex = findIndex(playlist, song);

  currentIndex++;

  playlist.splice(currentIndex, 0, song);

  if (fpIndex > -1) {
    if (currentIndex > fpIndex) {
      playlist.splice(fpIndex, 1);
      currentIndex--;
    } else {
      playlist.splice(fpIndex + 1, 1);
    }
  }

  var currentSIndex = findIndex(sequenceList, currentSong) + 1;

  var fsIndex = findIndex(sequenceList, song);

  sequenceList.splice(currentSIndex, 0, song);

  if (fsIndex > -1) {
    if (currentSIndex > fsIndex) {
      sequenceList.splice(fsIndex, 1);
    } else {
      sequenceList.splice(fsIndex + 1, 1);
    }
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], currentIndex);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* SET_FULL_SCREEN */], true);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
};

var deleteSong = function deleteSong(_ref4, song) {
  var commit = _ref4.commit,
      state = _ref4.state;

  var playlist = state.playlist.slice();
  var sequenceList = state.sequenceList.slice();
  var currentIndex = state.currentIndex;
  var pIndex = findIndex(playlist, song);
  playlist.splice(pIndex, 1);
  var sIndex = findIndex(sequenceList, song);
  sequenceList.splice(sIndex, 1);
  if (currentIndex > pIndex || currentIndex === playlist.length) {
    currentIndex--;
  }

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], playlist);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], sequenceList);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], currentIndex);

  if (!playlist.length) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], false);
  } else {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], true);
  }
};

var deleteSongList = function deleteSongList(_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["g" /* SET_CURRENT_INDEX */], -1);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SET_PLAYLIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* SET_SEQUENCE_LIST */], []);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* SET_PLAYING_STATE */], false);
};

var saveFavoriteList = function saveFavoriteList(_ref6, song) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["i" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["b" /* saveFavorite */])(song));
};

var deleteFavoriteList = function deleteFavoriteList(_ref7, song) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["i" /* SET_FAVORITE_LIST */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["c" /* deleteFavorite */])(song));
};

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singer", function() { return singer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playing", function() { return playing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullScreen", function() { return fullScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "playlist", function() { return playlist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequenceList", function() { return sequenceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mode", function() { return mode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIndex", function() { return currentIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentSong", function() { return currentSong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disc", function() { return disc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteList", function() { return favoriteList; });
var singer = function singer(state) {
  return state.singer;
};
var playing = function playing(state) {
  return state.playing;
};
var fullScreen = function fullScreen(state) {
  return state.fullScreen;
};
var playlist = function playlist(state) {
  return state.playlist;
};
var sequenceList = function sequenceList(state) {
  return state.sequenceList;
};
var mode = function mode(state) {
  return state.mode;
};
var currentIndex = function currentIndex(state) {
  return state.currentIndex;
};
var currentSong = function currentSong(state) {
  return state.playlist[state.currentIndex] || {};
};
var disc = function disc(state) {
  return state.disc;
};
var favoriteList = function favoriteList(state) {
  return state.favoriteList;
};

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(143);


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_SINGER */], function (state, singer) {
  state.singer = singer;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_PLAYING_STATE */], function (state, flag) {
  state.playing = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_FULL_SCREEN */], function (state, flag) {
  state.fullScreen = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_PLAYLIST */], function (state, list) {
  state.playlist = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SET_SEQUENCE_LIST */], function (state, list) {
  state.sequenceList = list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SET_PLAY_MODE */], function (state, mode) {
  state.mode = mode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SET_CURRENT_INDEX */], function (state, index) {
  state.currentIndex = index;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_DISC */], function (state, disc) {
  state.disc = disc;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_FAVORITE_LIST */], function (state, list) {
  state.favoriteList = list;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_config__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_cache__ = __webpack_require__(141);



var state = {
  singer: {},
  playing: false,
  fullScreen: false,
  playlist: [],
  sequenceList: [],
  mode: __WEBPACK_IMPORTED_MODULE_0_common_js_config__["a" /* playMode */].sequence,
  currentIndex: -1,
  disc: {},
  favoriteList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_common_js_cache__["a" /* loadFavorite */])()
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_player_player__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_player_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_player_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_audiobook_audiobook_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_audiobook_audiobook_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_audiobook_audiobook_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    MHeader: __WEBPACK_IMPORTED_MODULE_0_components_m_header_m_header___default.a,

    Audiobook: __WEBPACK_IMPORTED_MODULE_2_components_audiobook_audiobook_vue___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_1_components_player_player___default.a
  }
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    text: {
      type: String,
      default: ''
    },
    confirmBtnText: {
      type: String,
      default: '確定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    }
  },
  data: function data() {
    return {
      showFlag: false
    };
  },

  methods: {
    show: function show() {
      this.showFlag = true;
    },
    hide: function hide() {
      this.showFlag = false;
    },
    cancel: function cancel() {
      this.hide();
      this.$emit('cancel');
    },
    confirm: function confirm() {
      this.hide();
      this.$emit('confirm');
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_scroll_scroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_loading_loading__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_dom__ = __webpack_require__(89);






var ANCHOR_HEIGHT = 18;
var TITLE_HEIGHT = 30;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollY: -1,

      currentIndex: 0,

      diff: -1
    };
  },

  props: {
    data: Array,
    default: []
  },
  computed: {
    shortcutList: function shortcutList() {
      return this.data.map(function (group) {
        return group.title.substr(0, 1);
      });
    },
    fixedTitle: function fixedTitle() {
      if (this.scrollY > 0) {
        return;
      }
      return this.data[this.currentIndex] ? this.data[this.currentIndex].title : '';
    }
  },
  created: function created() {
    this.touch = {};
    this.listenScroll = true;
    this.listHeight = [];
    this.probeType = 3;
  },

  methods: {
    selectItem: function selectItem(item) {
      this.$emit('select', item);
    },
    onShortcutTouchStart: function onShortcutTouchStart(e) {
      console.log('touched', e.target);
      var anchorIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_common_js_dom__["b" /* getData */])(e.target, 'index');

      var firstTouch = e.touches[0];

      this.touch.y1 = firstTouch.pageY;
      this.touch.anchorIndex = anchorIndex;
      this._scrollTo(anchorIndex);
    },
    onShortcutTouchMove: function onShortcutTouchMove(e) {
      console.log('onmove');
      var firstTouch = e.touches[0];
      this.touch.y2 = firstTouch.pageY;
      var delta = (this.touch.y2 - this.touch.y1) / ANCHOR_HEIGHT | 0;
      console.log(delta);

      var anchorIndex = delta + parseInt(this.touch.anchorIndex);
      this._scrollTo(anchorIndex);
    },
    scroll: function scroll(pos) {
      this.scrollY = pos.y;
      console.log('Y', this.scrollY);
    },
    _scrollTo: function _scrollTo(index) {
      if (!index && index !== 0) {
        return;
      }

      if (index < 0) {
        index = 0;
      }

      this.scrollY = -this.listHeight[index];

      this.$refs.listview.scrollToElement(this.$refs.listGroup[index], 0);
    },
    _calculateaHeight: function _calculateaHeight() {
      this.listHeight = [];
      var list = this.$refs.listGroup;
      var height = 0;

      this.listHeight.push(height);
      for (var i = 0; i < list.length; i++) {
        var item = list[i];

        height += item.clientHeight;
        this.listHeight.push(height);
      }
    }
  },

  watch: {
    data: function data() {
      var _this = this;

      setTimeout(function () {
        _this._calculateaHeight();
      }, 20);
    },
    scrollY: function scrollY(newY) {
      var listHeight = this.listHeight;

      if (newY > 0) {
        this.currentIndex = 0;
        return;
      }

      for (var i = 0; i < listHeight.length; i++) {
        var height1 = listHeight[i];
        var height2 = listHeight[i + 1];

        if (-newY >= height1 && -newY < height2) {
          this.currentIndex = i;
          this.diff = height2 - -newY;

          return;
        }
      }

      this.currentIndex = listHeight.length - 2;
    },
    diff: function diff(newVal) {
      var fixedTop = newVal > 0 && newVal < TITLE_HEIGHT ? newVal - TITLE_HEIGHT : 0;

      if (this.fixedTop === fixedTop) {
        console.log('this', this.fixedTop, fixedTop);
        return;
      }
      this.fixedTop = fixedTop;
      this.$refs.fixed.style.transform = 'translate3d(0,' + fixedTop + 'px,0)';
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_0_base_scroll_scroll___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_1_base_loading_loading___default.a
  }
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      default: '正在載入中'
    }
  }
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_dom__ = __webpack_require__(89);




var progressBtnWidth = 16;
var transform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_common_js_dom__["a" /* prefixStyle */])('transform');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    percent: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    this.touch = {};
  },

  methods: {
    progressTouchStart: function progressTouchStart(e) {
      this.touch.initiated = true;
      this.touch.startX = e.touches[0].pageX;
      this.touch.left = this.$refs.progress.clientWidth;
    },
    progressTouchMove: function progressTouchMove(e) {
      if (!this.touch.initiated) {
        return;
      }
      var deltaX = e.touches[0].pageX - this.touch.startX;
      var offsetWidth = Math.min(this.$refs.progressBar.clientWidth - progressBtnWidth, Math.max(0, this.touch.left + deltaX));
      this._offset(offsetWidth);
    },
    progressTouchEnd: function progressTouchEnd() {
      this.touch.initiated = false;
      this._triggerPercent();
    },
    progressClick: function progressClick(e) {
      var rect = this.$refs.progressBar.getBoundingClientRect();
      var offsetWidth = e.pageX - rect.left;
      this._offset(offsetWidth);

      this._triggerPercent();
    },
    _triggerPercent: function _triggerPercent() {
      var barWidth = this.$refs.progressBar.clientWidth - progressBtnWidth;
      var percent = this.$refs.progress.clientWidth / barWidth;
      this.$emit('percentChange', percent);
    },
    _offset: function _offset(offsetWidth) {
      this.$refs.progress.style.width = offsetWidth + 'px';
      this.$refs.progressBtn.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
    }
  },
  watch: {
    percent: function percent(newPercent) {
      if (newPercent >= 0 && !this.touch.initiated) {
        var barWidth = this.$refs.progressBar.clientWidth - progressBtnWidth;
        var offsetWidth = newPercent * barWidth;
        this._offset(offsetWidth);
      }
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    radius: {
      type: Number,
      default: 100
    },
    percent: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dashArray: Math.PI * 100
    };
  },

  computed: {
    dashOffset: function dashOffset() {
      return (1 - this.percent) * this.dashArray;
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_better_scroll__ = __webpack_require__(259);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: null
    },

    listenScroll: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this._initScroll();
    }, 20);
  },

  methods: {
    _initScroll: function _initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }
      this.scroll = new __WEBPACK_IMPORTED_MODULE_0_better_scroll__["a" /* default */](this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click
      });

      if (this.listenScroll) {
        var me = this;
        this.scroll.on('scroll', function (pos) {
          me.$emit('scroll', pos);
        });
      }
    },
    enable: function enable() {
      this.scroll && this.scroll.enable();
    },
    disable: function disable() {
      this.scroll && this.scroll.disable();
    },
    refresh: function refresh() {
      this.scroll && this.scroll.refresh();
    },
    scrollTo: function scrollTo() {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments);
    },
    scrollToElement: function scrollToElement() {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments);
    }
  },
  watch: {
    data: function data() {
      var _this2 = this;

      setTimeout(function () {
        _this2.refresh();
      }, 20);
    }
  }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    songs: {
      type: Array,
      default: []
    }
  },
  methods: {
    selectItem: function selectItem(song, index) {
      this.$emit('select', song, index);
    },
    getDesc: function getDesc(song) {
      return '' + song.album;
    },
    getPhoto: function getPhoto(song) {
      return '/static/photo/' + song.image;
    },
    getDuration: function getDuration(song) {
      console.log(song.duration);
      var min = parseInt(song.duration / 60);
      var sec = song.duration % 60;
      if (sec < 10) {
        sec = '0' + sec;
      }
      return min + ':' + sec;
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    switches: {
      type: Array,
      default: []
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    switchItem: function switchItem(index) {
      this.$emit('switch', index);
    }
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_music_list_music_list__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_music_list_music_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_music_list_music_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_recommend__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_song__ = __webpack_require__(90);










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    title: function title() {},
    bgImage: function bgImage() {
      return this.disc.imgDiscUrl;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['disc'])),
  data: function data() {
    return {
      songs: []
    };
  },
  created: function created() {
    console.log('audiobook');
    this._getSongList();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    _getSongList: function _getSongList() {
      var _this = this;

      console.log('audiobook');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_recommend__["a" /* getAudioBook */])(this.$route.params.id).then(function (res) {
        if (res.code === __WEBPACK_IMPORTED_MODULE_3_api_config__["a" /* ERR_OK */]) {
          console.log('res.data', res.data.book);
          var audiobook = res.data.book;
          var item = {
            imgTitleUrl: audiobook.imgMagTitleUrl,
            imgDiscUrl: audiobook.imgDiscUrl,
            controllerBackgroundColor: audiobook.controllerBackgroundColor
          };
          _this.setDisc(item);
          _this.songs = _this._normalizeSongs(res.data.book.list);
        }
      });

      console.log('songs', this.songs);
    },
    _normalizeSongs: function _normalizeSongs(list) {
      console.log('_normalizeSongs->', list);
      var ret = [];
      list.forEach(function (musicData) {
        if (musicData.songUrl && musicData.imgUrl) {
          ret.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_common_js_song__["a" /* createSong */])(musicData));
        }
      });
      console.log('disc-normalizeSong', ret);
      return ret;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapMutations */])({
    setDisc: 'SET_DISC'
  })),
  components: {
    MusicList: __WEBPACK_IMPORTED_MODULE_1_components_music_list_music_list___default.a
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    titleImgUrl: function titleImgUrl() {
      return this.disc.imgTitleUrl;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['disc']))
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_song_list_song_list__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_base_song_list_song_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_base_song_list_song_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_scroll_scroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_loading_loading__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_loading_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_loading_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_mixin__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(31);









var RESERVED_HEIGHT = 40;

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4_common_js_mixin__["b" /* playlistMixin */]],
  props: {
    bgImage: {
      type: String,
      default: ''
    },
    songs: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      scrollY: 0
    };
  },
  created: function created() {
    this.probeType = 3;
    this.listenScroll = true;
  },
  mounted: function mounted() {
    this.imageHeight = this.$refs.bgImage.clientHeight;
    this.minTranslateY = -this.imageHeight + RESERVED_HEIGHT;

    this.$refs.list.$el.style.top = this.imageHeight + 'px';
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handlePlaylist: function handlePlaylist(playlist) {
      var bottom = playlist.length > 0 ? '60px' : '';
      this.$refs.list.$el.style.bottom = bottom;
      this.$refs.list.refresh();
    },
    scroll: function scroll(pos) {
      this.scrollY = pos.y;
    },
    back: function back() {
      this.$router.back();
    },
    selectItem: function selectItem(item, index) {
      this.selectPlay({
        list: this.songs,
        index: index
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['selectPlay'])),
  computed: {
    bgStyle: function bgStyle() {
      return 'background-image:url(' + this.bgImage + ')';
    }
  },
  watch: {
    scrollY: function scrollY(newY) {
      var translateY = Math.max(this.minTranslateY, newY);
      var zIndex = 0;
      var scale = 1;
      this.$refs.layer.style['transform'] = 'translate3d(0,' + translateY + 'px,0';
      var percent = Math.abs(newY / this.imageHeight);
      if (newY > 0) {
        zIndex = 10;
        scale = 1 + percent;
      }
      if (newY < this.minTranslateY) {
        zIndex = 10;
        this.$refs.bgImage.style.paddingTop = 0;
        this.$refs.bgImage.style.height = RESERVED_HEIGHT + 'px';
      } else {
        this.$refs.bgImage.style.paddingTop = '70%';
        this.$refs.bgImage.style.height = 0;
      }
      this.$refs.bgImage.style.zIndex = zIndex;
      this.$refs.bgImage.style['transform'] = 'scale(' + scale + ')';
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_2_base_scroll_scroll___default.a,
    Loading: __WEBPACK_IMPORTED_MODULE_3_base_loading_loading___default.a,
    SongList: __WEBPACK_IMPORTED_MODULE_1_base_song_list_song_list___default.a
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_dom__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_config__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_js_util__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lyric_parser__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lyric_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lyric_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_base_scroll_scroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_common_js_mixin__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_base64__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_m_header_m_header__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_m_header_m_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_m_header_m_header__);

















var transform = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_dom__["a" /* prefixStyle */])('transform');
var transitionDuration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_dom__["a" /* prefixStyle */])('transitionDuration');

/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_11_common_js_mixin__["a" /* playerMixin */]],
  data: function data() {
    return {
      songReady: false,
      currentTime: 0,
      radius: 32,
      currentLyric: null,
      currentLineNum: 0,
      currentShow: 'cd',
      playingLyric: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    controllerBackgroundColor: function controllerBackgroundColor() {
      return this.disc.controllerBackgroundColor;
    },
    cdCls: function cdCls() {
      return this.playing ? 'play' : 'play pause';
    },
    playIcon: function playIcon() {
      return this.playing ? 'icon-pause' : 'icon-play';
    },
    iconMode: function iconMode() {
      return this.mode === __WEBPACK_IMPORTED_MODULE_6_common_js_config__["a" /* playMode */].sequence ? 'icon-sequence' : this.mode === __WEBPACK_IMPORTED_MODULE_6_common_js_config__["a" /* playMode */].loop ? 'icon-loop' : 'icon-random';
    },
    miniIcon: function miniIcon() {
      return this.playing ? 'icon-pause-mini' : 'icon-play-mini';
    },
    disableCls: function disableCls() {
      return this.songReady ? '' : 'disable';
    },
    percent: function percent() {
      return this.currentTime / this.currentSong.duration;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['fullScreen', 'playlist', 'currentSong', 'playing', 'currentIndex', 'mode', 'sequenceList', 'disc'])),
  created: function created() {
    this.touch = {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    created: function created() {
      this.touch = {};
    },
    back: function back() {
      this.setFullScreen(false);
    },
    open: function open() {
      this.setFullScreen(true);
    },
    enter: function enter(el, done) {
      var _getPosAndScale = this._getPosAndScale(),
          x = _getPosAndScale.x,
          y = _getPosAndScale.y,
          scale = _getPosAndScale.scale;

      console.log('x,y,scale', x, y, scale);
      var animation = {
        0: {
          transform: 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')'
        },
        80: {
          transform: 'translate3d(0,0,0) scale(1.1)'
        },
        100: {
          transform: 'translate3d(0,0,0) scale(1)'
        }
      };

      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.registerAnimation({
        name: 'move',
        animation: animation,
        presets: {
          duration: 800,
          easing: 'linear'
        }
      });

      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.runAnimation(this.$refs.cdWrapper, 'move', done);
    },
    afterEnter: function afterEnter() {
      __WEBPACK_IMPORTED_MODULE_2_create_keyframe_animation___default.a.unregisterAnimation('move');
      this.$refs.cdWrapper.style.animation = '';
    },
    leave: function leave(el, done) {
      this.$refs.cdWrapper.style.transition = 'all 0.8s';

      var _getPosAndScale2 = this._getPosAndScale(),
          x = _getPosAndScale2.x,
          y = _getPosAndScale2.y,
          scale = _getPosAndScale2.scale;

      this.$refs.cdWrapper.style[transform] = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')';
      this.$refs.cdWrapper.addEventListener('transitionend', done);
    },
    afterLeave: function afterLeave() {
      this.$refs.cdWrapper.style.transition = '';
      this.$refs.cdWrapper.style[transform] = '';
    },
    togglePlaying: function togglePlaying() {
      if (!this.songReady) {
        return;
      }
      this.setPlayingState(!this.playing);
      if (this.currentLyric) {
        this.currentLyric.togglePlay();
      }
      console.log('playing', this.playing);
    },
    end: function end() {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_6_common_js_config__["a" /* playMode */].loop) {
        this.loop();
      } else {
        this.next();
      }
    },
    loop: function loop() {
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
      if (this.currentLyric) {
        this.currentLyric.seek(0);
      }
    },
    next: function next() {
      if (!this.songReady) {
        return;
      }
      if (this.playlist.length === 1) {
        this.loop();
      } else {
        var index = this.currentIndex + 1;
        if (index === this.playlist.length) {
          index = 0;
        }
        this.setCurrentIndex(index);
        if (!this.playing) {
          this.togglePlaying();
        }
      }
      this.songReady = false;
    },
    prev: function prev() {
      if (!this.songReady) {
        return;
      }
      if (this.playlist.length === 1) {
        this.loop();
      } else {
        var index = this.currentIndex - 1;
        if (index === -1) {
          index = this.playlist.length - 1;
        }
        this.setCurrentIndex(index);
        if (!this.playing) {
          this.togglePlaying();
        }
      }
      this.songReady = false;
    },
    ready: function ready() {
      this.songReady = true;
    },
    error: function error() {
      this.songReady = true;
    },
    updateTime: function updateTime(e) {
      this.currentTime = e.target.currentTime;
    },
    format: function format(interval) {
      interval = interval | 0;
      var minute = interval / 60 | 0;
      var second = this._pad(interval % 60);
      return minute + ':' + second;
    },
    onProgressBarChange: function onProgressBarChange(percent) {
      var currentTime = this.currentSong.duration * percent;
      this.$refs.audio.currentTime = currentTime;
      if (!this.playing) {
        this.togglePlaying();
      }
      if (this.currentLyric) {}
    },
    changeMode: function changeMode() {
      var mode = (this.mode + 1) % 3;
      this.setPlayMode(mode);
      var list = null;
      if (mode === __WEBPACK_IMPORTED_MODULE_6_common_js_config__["a" /* playMode */].random) {
        list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_common_js_util__["a" /* shuffle */])(this.sequenceList);
      } else {
        list = this.sequenceList;
      }
      this.resetCurrentIndex(list);
      this.setPlayList(list);
    },
    resetCurrentIndex: function resetCurrentIndex(list) {
      var _this = this;

      var index = list.findIndex(function (item) {
        return item.id === _this.currentSong.id;
      });
      this.setCurrentIndex(index);
    },
    getLyric: function getLyric() {
      var myLyric = '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';
      var lyric = __WEBPACK_IMPORTED_MODULE_12_js_base64__["Base64"].decode(myLyric);
      this.currentLyric = new __WEBPACK_IMPORTED_MODULE_8_lyric_parser___default.a(lyric, this.handleLyric);
      if (this.playing) {
        this.currentLyric.play();
      }
      console.log('mygetLyric', this.currentLyric);
    },
    handleLyric: function handleLyric(_ref) {
      var lineNum = _ref.lineNum,
          txt = _ref.txt;

      this.currentLineNum = lineNum;
      if (lineNum > 5) {
        var lineEl = this.$refs.lyricLine[lineNum - 5];
        this.$refs.lyricList.scrollToElement(lineEl, 1000);
      } else {
        this.$refs.lyricList.scrollTo(0, 0, 1000);
      }
      this.playingLyric = txt;
    },
    showPlayList: function showPlayList() {
      this.$refs.playlist.show();
    },
    middleTouchStart: function middleTouchStart(e) {
      this.touch.initiated = true;
      var touch = e.touches[0];
      this.touch.startX = touch.pageX;
      this.touch.startY = touch.pageY;
    },
    middleTouchMove: function middleTouchMove(e) {
      if (!this.touch.initiated) {
        return;
      }
      var touch = e.touches[0];
      var deltaX = touch.pageX - this.touch.startX;
      console.log('deltax', deltaX);
      var deltaY = touch.pageY - this.touch.startY;
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        return;
      }
      var left = this.currentShow === 'cd' ? 0 : -window.innerWidth;
      var offsetWidth = Math.min(0, Math.max(-window.innerWidth, left + deltaX));
      this.touch.percent = Math.abs(offsetWidth / window.innerWidth);
      this.$refs.lyricList.$el.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
      this.$refs.lyricList.$el.style[transitionDuration] = 0;
      console.log('offsetWidth', offsetWidth, 'left', left);
      this.$refs.middleL.style.opacity = 1 - this.touch.percent;
      this.$refs.middleL.style[transitionDuration] = 0;
    },
    middleTouchEnd: function middleTouchEnd() {
      var offsetWidth = void 0;
      var opacity = void 0;
      if (this.currentShow === 'cd') {
        if (this.touch.percent > 0.2) {
          offsetWidth = -window.innerWidth;
          opacity = 0;
          this.currentShow = 'lyric';
        } else {
          offsetWidth = 0;
          opacity = 1;
        }
      } else {
        if (this.touch.percent < 0.8) {
          offsetWidth = 0;
          this.currentShow = 'cd';
          opacity = 1;
        } else {
          offsetWidth = -window.innerWidth;
          opacity = 0;
        }
      }
      this.$refs.lyricList.$el.style[transform] = 'translate3d(' + offsetWidth + 'px,0,0)';
      var time = 300;
      this.$refs.lyricList.$el.style[transitionDuration] = time + 'ms';
      this.$refs.middleL.style.opacity = opacity;
      this.$refs.middleL.style[transitionDuration] = time + 'ms';
    },
    _pad: function _pad(num) {
      var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      var len = num.toString().length;
      while (len < n) {
        num = '0' + num;
        len++;
      }
      return num;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])({
    setFullScreen: 'SET_FULL_SCREEN',
    setPlayingState: 'SET_PLAYING_STATE',
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setPlayMode: 'SET_PLAY_MODE',
    setPlayList: 'SET_PLAYLIST'
  }), {
    _getPosAndScale: function _getPosAndScale() {
      var targetWidth = 40;
      var paddingLeft = 40;
      var paddingBottom = 30;
      var paddingTop = 80;

      var width = window.innerWidth * 0.8;

      var scale = targetWidth / width;

      var x = -(window.innerWidth / 2 - paddingLeft);
      var y = window.innerHeight - paddingTop - paddingBottom - width / 2;
      return {
        x: x, y: y, scale: scale
      };
    }
  }),
  watch: {
    currentSong: function currentSong(newSong, oldSong) {
      var _this2 = this;

      console.log('newSong', newSong.lyric);
      if (!newSong.id) {
        return;
      }
      if (newSong.id === oldSong.id) {
        return;
      }
      if (this.currentLyric) {
        this.currentLyric.stop();
        this.currentTime = 0;
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.$refs.audio.currentTime = 0;
        _this2.$refs.audio.play();
      }, 1000);
    },
    playing: function playing(newPlaying) {
      var audio = this.$refs.audio;
      this.$nextTick(function () {
        newPlaying ? audio.play() : audio.pause();
      });
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_4_base_progress_bar_progress_bar___default.a,
    ProgressCircle: __WEBPACK_IMPORTED_MODULE_5_base_progress_circle_progress_circle___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_9_base_scroll_scroll___default.a,
    PlayList: __WEBPACK_IMPORTED_MODULE_10_components_playlist_playlist___default.a,
    MHeader: __WEBPACK_IMPORTED_MODULE_13_components_m_header_m_header___default.a
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_config__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_mixin__ = __webpack_require__(67);









/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5_common_js_mixin__["a" /* playerMixin */]],
  data: function data() {
    return {
      showFlag: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    modeText: function modeText() {
      return this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].sequence ? '順序播放' : this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random ? '隨機播放' : '單曲循環';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['sequenceList', 'currentSong', 'playlist', 'mode'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    show: function show() {
      var _this = this;

      this.showFlag = true;
      setTimeout(function () {
        _this.$refs.listContent.refresh();
        _this.scrollToCurrent(_this.currentSong);
      }, 20);
    },
    hide: function hide() {
      this.showFlag = false;
    },
    getCurrentIcon: function getCurrentIcon(item) {
      if (this.currentSong.id === item.id) {
        return 'icon-play';
      } else {
        return '';
      }
    },
    selectItem: function selectItem(item, index) {
      if (this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random) {
        index = this.playlist.findIndex(function (song) {
          return song.id === item.id;
        });
      }
      this.setCurrentIndex(index);
      this.setPlayingState(true);
    },
    scrollToCurrent: function scrollToCurrent(current) {
      var index = this.sequenceList.findIndex(function (song) {
        return current.id === song.id;
      });
      this.$refs.listContent.scrollToElement(this.$refs.listItem[index], 300);
    },
    deleteOne: function deleteOne(item) {
      this.deleteSong(item);
      if (!this.playlist.length) {
        this.hide();
      }
    },
    showConfirm: function showConfirm() {
      this.$refs.confirm.show();
    },
    confirmClear: function confirmClear() {
      this.deleteSongList();
      this.hide();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])({
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setPlayingState: 'SET_PLAYING_STATE'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['deleteSong', 'deleteSongList'])),
  watch: {
    currentSong: function currentSong(newSong, oldSong) {
      if (!this.showFlag || newSong.id === oldSong.id) {
        return;
      }
      this.scrollToCurrent(newSong);
    }
  },
  components: {
    Scroll: __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default.a,
    Confirm: __WEBPACK_IMPORTED_MODULE_4_base_confirm_confirm___default.a
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_singer__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_song__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_music_list_music_list__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_music_list_music_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_music_list_music_list__);









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      songs: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    title: function title() {
      return this.singer.name;
    },
    bgImage: function bgImage() {
      return this.singer.avatar;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['singer'])),
  created: function created() {
    this._getDetail();
  },

  methods: {
    _getDetail: function _getDetail() {
      var _this = this;

      console.log('singer->', this.singer.id);
      if (!this.singer.id) {
        this.$router.push('/singer');
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_api_singer__["a" /* getSingerDetail */])(this.singer.id).then(function (res) {
        if (res.code === __WEBPACK_IMPORTED_MODULE_3_api_config__["a" /* ERR_OK */]) {
          _this.songs = _this._normalizeSongs(res.data.list);
          console.log(_this.songs);
        }
      });
    },
    _normalizeSongs: function _normalizeSongs(list) {
      var ret = [];
      list.forEach(function (item) {
        var musicData = item.musicData;

        if (musicData.songid && musicData.albummid) {
          ret.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_common_js_song__["a" /* createSong */])(musicData));
        }
      });
      return ret;
    }
  },
  components: {
    MusicList: __WEBPACK_IMPORTED_MODULE_5_components_music_list_music_list___default.a
  }
});

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_singer__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_api_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_singer__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_listview_listview__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_listview_listview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_listview_listview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(31);









var HOT_NAME = '熱門';
var HOT_SINGER_LEN = 10;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      singers: []
    };
  },
  created: function created() {
    this._getSingerList();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selectSinger: function selectSinger(singer) {
      console.log('router.push', singer);
      this.$router.push({
        path: '/singer/' + singer.id
      });
      this.setSinger(singer);
    },
    _getSingerList: function _getSingerList() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_api_singer__["b" /* getSingerList */])().then(function (res) {
        if (res.code === __WEBPACK_IMPORTED_MODULE_2_api_config__["a" /* ERR_OK */]) {
          _this.singers = _this._normalizeSinger(res.data.list);
        }
      });
    },
    _normalizeSinger: function _normalizeSinger(list) {
      console.log('inNormalize', list);
      var map = {
        hot: {
          title: HOT_NAME,
          items: []
        }
      };
      list.forEach(function (item, index) {
        if (index < HOT_SINGER_LEN) {
          map.hot.items.push(new __WEBPACK_IMPORTED_MODULE_3_common_js_singer__["a" /* default */]({
            id: item.Fsinger_mid,
            name: item.Fsinger_name
          }));
        }
        var key = item.Findex;
        if (!map[key]) {
          map[key] = {
            title: key,
            items: []
          };
        }
        map[key].items.push(new __WEBPACK_IMPORTED_MODULE_3_common_js_singer__["a" /* default */]({
          id: item.Fsinger_mid,
          name: item.Fsinger_name
        }));
      });

      var hot = [];
      var ret = [];

      for (var key in map) {
        var val = map[key];
        if (val.title.match(/[a-zA-Z]/)) {
          ret.push(val);
        } else if (val.title === HOT_NAME) {
          hot.push(val);
        }
      }

      ret.sort(function (a, b) {
        return a.title.charCodeAt(0) - b.title.charCodeAt(0);
      });

      return hot.concat(ret);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapMutations */])({
    setSinger: 'SET_SINGER'
  })),
  components: {
    ListView: __WEBPACK_IMPORTED_MODULE_4_base_listview_listview___default.a
  }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_m_header_m_header__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_m_header_m_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_m_header_m_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_switches_switches__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_base_switches_switches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_base_switches_switches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_song_list_song_list__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_base_song_list_song_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_base_song_list_song_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_song__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_js_mixin__ = __webpack_require__(67);











/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7_common_js_mixin__["b" /* playlistMixin */]],
  data: function data() {
    return {
      currentIndex: 0,

      switches: [{ name: '我喜歡的' }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['favoriteList'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    handlePlaylist: function handlePlaylist(playlist) {
      console.log('handlePlaylist');
      var bottom = playlist.length > 0 ? '60px' : '';
      this.$refs.listWrapper.style.bottom = bottom;
      this.$refs.favoriteList && this.$refs.favoriteList.refresh();
      this.$refs.playList && this.$refs.playList.refresh();
    },
    switchItem: function switchItem(index) {
      this.currentIndex = index;
    },
    selectSong: function selectSong(song) {
      console.log('selectSong');
      this.insertSong(new __WEBPACK_IMPORTED_MODULE_5_common_js_song__["b" /* default */](song));
    },
    back: function back() {
      this.$router.back();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapActions */])(['insertSong'])),
  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_2_base_switches_switches___default.a,
    Scroll: __WEBPACK_IMPORTED_MODULE_3_base_scroll_scroll___default.a,
    SongList: __WEBPACK_IMPORTED_MODULE_4_base_song_list_song_list___default.a,
    MHeader: __WEBPACK_IMPORTED_MODULE_1_components_m_header_m_header___default.a
  }
});

/***/ }),

/***/ 506:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 507:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return commonParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR_OK; });

var commonParams = {
  g_tk: 5381,
  inCharset: 'utf-8',
  outCharset: 'utf-8',
  notice: 0,
  format: 'jsonp'
};

var options = {
  param: 'jsonpCallback'
};

var ERR_OK = 0;

/***/ }),

/***/ 510:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 511:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 515:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 520:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 521:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 522:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 523:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  "data-v-098b964b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  "data-v-05c3be2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(572),
  /* scopeId */
  "data-v-5e78f22e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  "data-v-6f6c44ab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  "data-v-768433c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(569),
  /* scopeId */
  "data-v-409e5c2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(571),
  /* scopeId */
  "data-v-4280cc4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  "data-v-94643be4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  "data-v-0952ee4e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  "data-v-9a124158",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  "data-v-2a7e9064",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  "data-v-02ed28be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 560:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "user-center"
  }, [_c('m-header'), _vm._v(" "), _c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$route.params.id))]), _vm._v(" "), _c('div', {
    staticClass: "switches-wrapper"
  }, [_c('switches', {
    attrs: {
      "switches": _vm.switches,
      "currentIndex": _vm.currentIndex
    },
    on: {
      "switch": _vm.switchItem
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "listWrapper",
    staticClass: "list-wrapper"
  }, [(_vm.currentIndex === 0) ? _c('scroll', {
    ref: "favoriteList",
    staticClass: "list-scroll",
    attrs: {
      "data": _vm.favoriteList
    }
  }, [_c('div', {
    staticClass: "list-inner"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.favoriteList
    },
    on: {
      "select": _vm.selectSong
    }
  })], 1)]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll', {
    ref: "listview",
    staticClass: "listview",
    attrs: {
      "data": _vm.data,
      "listenScroll": _vm.listenScroll,
      "probeType": _vm.probeType
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('ul', _vm._l((_vm.data), function(group, index) {
    return _c('li', {
      key: index,
      ref: "listGroup",
      refInFor: true,
      staticClass: "list-group"
    }, [_c('h2', {
      staticClass: "list-group-title"
    }, [_vm._v(_vm._s(group.title))]), _vm._v(" "), _c('ul', _vm._l((group.items), function(item, index) {
      return _c('li', {
        key: index,
        staticClass: "list-group-item",
        on: {
          "click": function($event) {
            _vm.selectItem(item)
          }
        }
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (item.avatar),
          expression: "item.avatar"
        }],
        staticClass: "avatar"
      }), _vm._v(" "), _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(item.name))])])
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "list-shortcut",
    on: {
      "touchstart": _vm.onShortcutTouchStart,
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onShortcutTouchMove($event)
      }
    }
  }, [_c('ul', _vm._l((_vm.shortcutList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "item",
      class: {
        'current': _vm.currentIndex === index
      },
      attrs: {
        "data-index": index
      }
    }, [_vm._v("\n        " + _vm._s(item) + "\n      ")])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fixedTitle),
      expression: "fixedTitle"
    }],
    ref: "fixed",
    staticClass: "list-fixed"
  }, [_c('div', {
    staticClass: "fixed-title"
  }, [_vm._v(_vm._s(_vm.fixedTitle))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.data.length),
      expression: "!data.length"
    }],
    staticClass: "loading-container"
  }, [_c('Loading')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('music-list', {
    attrs: {
      "title": _vm.title,
      "bg-image": _vm.bgImage,
      "songs": _vm.songs
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  search\n")])
},staticRenderFns: []}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "confirm",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "confirm-wrapper"
  }, [_c('div', {
    staticClass: "confirm-content"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', {
    staticClass: "operate-btn left",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelBtnText))]), _vm._v(" "), _c('div', {
    staticClass: "operate-btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmBtnText))])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "width": "24",
      "height": "24",
      "src": __webpack_require__(546)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "singer",
    staticClass: "singer"
  }, [_c('list-view', {
    attrs: {
      "data": _vm.singers
    },
    on: {
      "select": _vm.selectSinger
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-list"
  }, [_c('ul', _vm._l((_vm.songs), function(song, index) {
    return _c('li', {
      key: song.id,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(song, index)
        }
      }
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (song.image),
        expression: "song.image"
      }]
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h2', {
      staticClass: "name"
    }, [_vm._v(_vm._s(song.name))]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(_vm.getDesc(song)))])]), _vm._v(" "), _c('div', {
      staticClass: "interval"
    }, [_vm._v(_vm._s(_vm.getDuration(song)))])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playlist.length > 0),
      expression: "playlist.length>0"
    }],
    staticClass: "player"
  }, [_c('transition', {
    attrs: {
      "name": "normal"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen),
      expression: "fullScreen"
    }],
    staticClass: "normal-player",
    style: ({
      background: _vm.controllerBackgroundColor
    })
  }, [_c('m-header'), _vm._v(" "), _c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.album)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.middleTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.middleTouchMove($event)
      },
      "touchend": _vm.middleTouchEnd
    }
  }, [_c('div', {
    ref: "middleL",
    staticClass: "middle-l"
  }, [_c('div', {
    ref: "cdWrapper",
    staticClass: "cd-wrapper"
  }, [_c('div', {
    staticClass: "cd",
    class: _vm.cdCls
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.currentSong.image
    }
  })])])]), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentShow === 'lyric'),
      expression: "currentShow==='lyric'"
    }],
    ref: "lyricList",
    staticClass: "middle-r"
  }, [_c('div', {
    staticClass: "lyric-wrapper"
  }, [_c('p', {
    ref: "lyricLine",
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.lyric)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "dot-wrapper"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'cd'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'lyric'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "time time-l"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('progress-bar', {
    attrs: {
      "percent": _vm.percent
    },
    on: {
      "percentChange": _vm.onProgressBarChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "time time-r"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentSong.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "operators"
  }, [_c('div', {
    staticClass: "icon i-left",
    on: {
      "click": _vm.changeMode
    }
  }, [_c('i', {
    class: _vm.iconMode
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-left",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-prev",
    on: {
      "click": _vm.prev
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-center",
    class: _vm.disableCls
  }, [_c('i', {
    class: _vm.playIcon,
    on: {
      "click": _vm.togglePlaying
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-next",
    on: {
      "click": _vm.next
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.getFavoriteIcon(_vm.currentSong),
    on: {
      "click": function($event) {
        _vm.toggleFavorite(_vm.currentSong)
      }
    }
  })])])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mini"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    style: ({
      background: _vm.controllerBackgroundColor
    }),
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.cdCls,
    attrs: {
      "width": "40",
      "height": "40",
      "src": _vm.currentSong.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('ProgressCircle', {
    attrs: {
      "radius": _vm.radius,
      "percent": _vm.percent
    }
  }, [_c('i', {
    staticClass: "icon-mini",
    class: _vm.miniIcon,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.togglePlaying($event)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])]), _vm._v(" "), _c('play-list', {
    ref: "playlist"
  }), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "type": "audio/mpeg",
      "src": _vm.currentSong.url
    },
    on: {
      "play": _vm.ready,
      "error": _vm.error,
      "timeupdate": _vm.updateTime,
      "ended": _vm.end
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-list",
    attrs: {
      "id": "musiclist"
    }
  }, [_c('div', {
    ref: "bgImage",
    staticClass: "bg-image",
    style: (_vm.bgStyle)
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    ref: "layer",
    staticClass: "bg-layer"
  }), _vm._v(" "), _c('Scroll', {
    ref: "list",
    staticClass: "list",
    attrs: {
      "data": _vm.songs,
      "probe-type": _vm.probeType,
      "listen-scroll": _vm.listenScroll
    },
    on: {
      "scroll": _vm.scroll
    }
  }, [_c('div', {
    staticClass: "song-list-wrapper"
  }, [_c('song-list', {
    attrs: {
      "songs": _vm.songs
    },
    on: {
      "select": _vm.selectItem
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.songs.length),
      expression: "!songs.length"
    }],
    staticClass: "loading-container"
  }, [_c('loading')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "list-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "playlist",
    on: {
      "click": _vm.hide
    }
  }, [_c('div', {
    staticClass: "list-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "list-header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconMode,
    on: {
      "click": _vm.changeMode
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.modeText))]), _vm._v(" "), _c('span', {
    staticClass: "clear",
    on: {
      "click": _vm.showConfirm
    }
  }, [_c('i', {
    staticClass: "icon-clear"
  })])])]), _vm._v(" "), _c('scroll', {
    ref: "listContent",
    staticClass: "list-content",
    attrs: {
      "data": _vm.sequenceList
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "list",
      "tag": "ul"
    }
  }, _vm._l((_vm.sequenceList), function(item, index) {
    return _c('li', {
      key: item.id,
      ref: "listItem",
      refInFor: true,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectItem(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "current",
      class: _vm.getCurrentIcon(item)
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "like",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.toggleFavorite(item)
        }
      }
    }, [_c('i', {
      class: _vm.getFavoriteIcon(item)
    })]), _vm._v(" "), _c('span', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.deleteOne(item)
        }
      }
    }, [_c('i', {
      staticClass: "icon-delete"
    })])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "list-operate"
  }, [_c('div', {
    staticClass: "add"
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("添加歌曲到列表")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', [_vm._v("關閉")])])], 1), _vm._v(" "), _c('confirm', {
    ref: "confirm",
    attrs: {
      "text": "是否清空播放列表",
      "confirmBtnText": "清空"
    },
    on: {
      "confirm": _vm.confirmClear
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "progressBar",
    staticClass: "progress-bar",
    on: {
      "click": _vm.progressClick
    }
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('div', {
    ref: "progress",
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    ref: "progressBtn",
    staticClass: "progress-btn-wrapper",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.progressTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.progressTouchMove($event)
      },
      "touchend": _vm.progressTouchEnd
    }
  }, [_c('div', {
    staticClass: "progress-btn"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-circle"
  }, [_c('svg', {
    attrs: {
      "width": _vm.radius,
      "height": _vm.radius,
      "viewBox": "0 0 100 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('circle', {
    staticClass: "progress-background",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "progress-bar",
    attrs: {
      "r": "50",
      "cx": "50",
      "cy": "50",
      "fill": "transparent",
      "stroke-dasharray": _vm.dashArray,
      "stroke-dashoffset": _vm.dashOffset
    }
  })]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "switches"
  }, _vm._l((_vm.switches), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "switch-item",
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.switchItem(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name) + " ")])])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('m-header'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('player')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  排行頁面\n")])
},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('music-list', {
    attrs: {
      "songs": _vm.songs,
      "bg-image": _vm.bgImage,
      "title": _vm.title
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-header",
    style: ({
      backgroundImage: 'url(' + _vm.titleImgUrl + ')'
    })
  }, [_vm._v(">\n  "), _c('div', {
    staticClass: "icon"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(567),
  /* scopeId */
  "data-v-2d01c5a9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playMode; });
var playMode = {
  sequence: 0,
  loop: 1,
  random: 2
};

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return playlistMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playerMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_config__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_js_util__ = __webpack_require__(142);





var playlistMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['playlist'])),
  mounted: function mounted() {
    this.handlePlaylist(this.playlist);
  },
  activated: function activated() {
    this.handlePlaylist(this.playlist);
  },

  watch: {
    playlist: function playlist(newVal) {
      this.handlePlaylist(newVal);
    }
  },
  methods: {
    handlePlaylist: function handlePlaylist() {
      throw new Error('component must implement handlePlaylist method');
    }
  }
};

var playerMixin = {
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    iconMode: function iconMode() {
      return this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].sequence ? 'icon-sequence' : this.mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].loop ? 'icon-loop' : 'icon-random';
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['sequenceList', 'playlist', 'currentSong', 'mode', 'favoriteList'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changeMode: function changeMode() {
      var mode = (this.mode + 1) % 3;
      this.setPlayMode(mode);
      var list = null;
      if (mode === __WEBPACK_IMPORTED_MODULE_2_common_js_config__["a" /* playMode */].random) {
        list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_common_js_util__["a" /* shuffle */])(this.sequenceList);
      } else {
        list = this.sequenceList;
      }
      this.resetCurrentIndex(list);
      this.setPlaylist(list);
    },
    resetCurrentIndex: function resetCurrentIndex(list) {
      var _this = this;

      var index = list.findIndex(function (item) {
        return item.id === _this.currentSong.id;
      });
      this.setCurrentIndex(index);
    },
    toggleFavorite: function toggleFavorite(song) {
      if (this.isFavorite(song)) {
        this.deleteFavoriteList(song);
      } else {
        this.saveFavoriteList(song);
      }
    },
    getFavoriteIcon: function getFavoriteIcon(song) {
      if (this.isFavorite(song)) {
        return 'icon-favorite';
      }
      return 'icon-not-favorite';
    },
    isFavorite: function isFavorite(song) {
      var index = this.favoriteList.findIndex(function (item) {
        return item.id === song.id;
      });
      return index > -1;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapMutations */])({
    setPlayMode: 'SET_PLAY_MODE',
    setPlaylist: 'SET_PLAYLIST',
    setCurrentIndex: 'SET_CURRENT_INDEX',
    setPlayingState: 'SET_PLAYING_STATE'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['saveFavoriteList', 'deleteFavoriteList']))
};

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addClass */
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["b"] = getData;
/* harmony export (immutable) */ __webpack_exports__["a"] = prefixStyle;
function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }

  el.classList.add(className);
}

function hasClass(el, className) {
  var reg = new RegExp('(^|//s) + className + ($|//s)');
  return reg.test(el.className);
}

function getData(el, name, val) {
  var prefix = 'data-';
  name = prefix + name;
  if (val) {
    return el.setAttribute(name, val);
  } else {
    return el.getAttribute(name);
  }
}

var elementStyle = document.createElement('div').style;

var vendor = function () {
  var transformNames = {
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform',
    standard: 'transform'
  };

  for (var key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key;
    }
  }

  return false;
}();

function prefixStyle(style) {
  if (vendor === false) {
    return false;
  }

  if (vendor === 'standard') {
    return style;
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1);
}

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSong;
/* unused harmony export filterSinger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_song__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_config__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_base64__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_base64__);







var Song = function () {
  function Song(_ref) {
    var id = _ref.id,
        mid = _ref.mid,
        singer = _ref.singer,
        name = _ref.name,
        album = _ref.album,
        duration = _ref.duration,
        image = _ref.image,
        url = _ref.url,
        lyric = _ref.lyric;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Song);

    this.id = id;
    this.mid = mid;
    this.singer = singer;
    this.name = name;
    this.album = album;
    this.duration = duration;
    this.image = image;
    this.url = url;
    this.lyric = lyric;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Song, [{
    key: 'getLyric',
    value: function getLyric() {
      var _this = this;

      if (this.lyric) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.lyric);
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_api_song__["a" /* getLyric */])(_this.mid).then(function (res) {
          if (res.retcode === __WEBPACK_IMPORTED_MODULE_4_api_config__["a" /* ERR_OK */]) {
            _this.lyric = __WEBPACK_IMPORTED_MODULE_5_js_base64__["Base64"].decode(res.lyric);
            console.log(_this.lyric);
            resolve(_this.lyric);
          } else {
            reject('no lyric');
          }
        });
      });
    }
  }]);

  return Song;
}();

/* harmony default export */ __webpack_exports__["b"] = (Song);

function createSong(musicData) {
  return new Song({
    id: musicData.id,
    mid: musicData.songmid,
    singer: filterSinger(musicData.singer),

    name: musicData.name,
    album: musicData.desc,
    duration: musicData.interval,

    image: musicData.imgUrl,

    url: musicData.songUrl,

    lyric: musicData.lyric
  });
}

function filterSinger(singer) {
  var ret = [];
  if (!singer) {
    return '';
  }
  singer.forEach(function (s) {
    ret.push(s.name);
  });

  return ret.join('/');
}

/***/ })

},[232]);


// WEBPACK FOOTER //
// static/js/app.55058c5cbea27c954abb.js